// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-title {\n  display: flex;\n  align-items: center;\n}\n.nav-title .icon {\n  align-items: center;\n  padding: 0 15px;\n}\n.nav-title .icon img {\n  width: 15px;\n}\n.nav-title .tile-name {\n  color: #363636;\n  font-weight: 600;\n  padding: 5px 10px;\n  font-size: 18px;\n}\n.nav-title h4 {\n  color: #363636;\n  font-weight: 600;\n  padding: 5px 10px;\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
